// extracted by mini-css-extract-plugin
module.exports = {"video-link":"j_r d-flex align-items-center my-2","video-link__link":"j_s ml-2"};